import { LandingNavbar } from '@/features/landing/components/landing-navbar';
import { CtaFooterSection } from '@/features/landing/components/cta-footer-section';
import { AboutHero } from '../components/about-hero';
import { AboutStory } from '../components/about-story';
import { AboutMission } from '../components/about-mission';
import { AboutTeam } from '../components/about-team';

export function AboutPage() {
  return (
    <div className="min-h-screen text-gray-900 dark:text-gray-100 overflow-x-hidden bg-gradient-to-br from-white via-blue-50/40 to-violet-50/30 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
      {/* Animated gradient mesh */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-0 -left-40 w-[600px] h-[600px] bg-blue-500/20 dark:bg-blue-500/10 rounded-full blur-[128px] animate-float" />
        <div
          className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-violet-500/20 dark:bg-violet-500/10 rounded-full blur-[128px] animate-float"
          style={{ animationDelay: '2s' }}
        />
        <div
          className="absolute bottom-0 left-1/3 w-[400px] h-[400px] bg-cyan-500/15 dark:bg-cyan-500/5 rounded-full blur-[128px] animate-float"
          style={{ animationDelay: '4s' }}
        />
      </div>

      {/* Dot grid */}
      <div
        className="fixed inset-0 pointer-events-none z-0"
        style={{
          backgroundImage: 'radial-gradient(circle, #94a3b8 1px, transparent 1px)',
          backgroundSize: '32px 32px',
          opacity: 0.15,
          maskImage: 'radial-gradient(ellipse 100% 100% at 50% 0%, black 50%, transparent 100%)',
          WebkitMaskImage:
            'radial-gradient(ellipse 100% 100% at 50% 0%, black 50%, transparent 100%)',
        }}
      />

      <LandingNavbar />
      <AboutHero />
      <AboutStory />
      <AboutMission />
      <AboutTeam />

      {/* Vault 346 (L0): el llamado a «posiciones abiertas» se quitó con /careers (vacantes inventadas). */}
      <CtaFooterSection />
    </div>
  );
}
